import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import { FullCLesson } from '@yandex-int/k-common/typings';
import { createSelector } from 'reselect';

import * as lessonAssignSelectors from 'common.components/lesson-view.assignment/selectors';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { getIsLessonEvaluable } from 'utils/lesson';

export const getDuration = createSelector(
    [
        lessonAssignSelectors.getDuration,
        lessonSelectors.getLesson,
        lessonSelectors.getIsPreparedLesson,
        lessonSelectors.getLessonAssignmentDate,
    ],
    (
        assignmentDuration: number | null,
        lesson: FullCLesson,
        isPreparedLesson: boolean,
        dateAssignment: string | null
    ): number | null => {
        if (!dateAssignment) {
            return assignmentDuration;
        }

        if (isPreparedLesson) {
            return lesson.meta.duration;
        }

        return lesson?.clesson?.duration || null;
    }
);

export const getReadonlyComment = createSelector(
    [lessonSelectors.getLesson],
    (lesson: FullCLesson | null): string | null => {
        return lesson?.meta.readonly_comment || null;
    }
);

export const getIsEvaluable = createSelector(
    [
        lessonAssignSelectors.getLessonMode,
        lessonSelectors.getLesson,
        lessonSelectors.getIsPreparedLesson,
        lessonSelectors.getLessonAssignmentDate,
    ],
    (
        lessonMode: CLESSON_MODES | null,
        lesson: FullCLesson,
        isPreparedLesson: boolean,
        dateAssignment: string | null
    ): boolean => {
        let mode;
        // TODO: в https://st.yandex-team.ru/EDUCATION-15612 выставление mode переедет в стор урока и эту логику
        // можно будет убрать получение mode из данных выдачи (брать из данных урока сразу)
        if (!dateAssignment) {
            mode = lessonMode;
        } else if (isPreparedLesson) {
            mode = lesson.meta.mode;
        } else {
            mode = lesson?.clesson?.mode;
        }

        return getIsLessonEvaluable(mode);
    }
);
